module.exports = __webpack_public_path__ + "static/media/FivePhasesMountainINTA0014_design_clean_v002.ac19819f.webp";